import React from 'react';
import PropTypes from 'prop-types';
import Personne from './Personne';
import Professionnel from './Professionnel';
import TextField from '@material-ui/core/TextField';
import IconButton from '@material-ui/core/IconButton';
import AddCircle from '@material-ui/icons/AddCircle';
import clientBo from '../../data/client/Client'
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import personneBo from '../../data/client/Personne';
import professionnelBo from '../../data/client/Professionnel';
import ClientService from '../../../services/clients/ClientService';
import ParentEditorComponent from '../../custom/ParentEditorComponent';

import "./Client.css";

class Client extends ParentEditorComponent {

    data = null;
    createdMode = true;

    constructor(props){
        super(props, "client", ClientService, clientBo);
        this.loadData();
        this.state = {
            pro: this.data.client.typeClient === 'pro' ? true : false,
            nbPersonne: this.data.personnes != null ? this.data.personnes.length : 0,
            nbProfessionnel: this.data.professionnel != null ? this.data.professionnel.length : 0,
            numero: this.data.client.numero === 0 ? '' : this.data.client.numero,
            typeClient: this.data.client.typeClient,
            obs: this.data.client.obs,
        };
    }

    loadData() {
        this.data = super.loadData(this.props.numeroClient);
        if (super.createdMode) {
            this.ajouterPersonne();
        }
    }

    ajouterPersonne() {
        this.data.personnes.push(Object.assign({}, personneBo));
    }

    supprimerPersonne() {
        this.data.personnes.splice(1, 1);
    }

    handleAddPers = () => {
        this.setState({nbPersonne: this.state.nbPersonne+1});;
        this.ajouterPersonne();
    }    

    handleRemovePers = () => {
        this.setState({nbPersonne: this.state.nbPersonne-1});;
        this.supprimerPersonne();
    }

    handleSubmit = (event) => {
        event.preventDefault();
        console.log("Enregistrement OK");
        console.log(this.data);
        return true;
    }

    handleChangeTypeClient = event => {
        var pro = event.target.value === 'pro' ? true : false;
        if(pro){
            this.data.personnes = [];
            this.setState({nbPersonne: 1});
            if(this.data.professionnel == null){
                this.data["professionnel"] = [];
            }
            this.data.professionnel.push(Object.assign({}, professionnelBo));
        } else {
            this.data.professionnel = [];
            if(this.data.personnes == null){
                this.data["personnes"] = [];
            }
            this.ajouterPersonne();
        }
        this.data.client.typeClient=event.target.value;
        this.setState({
            typeClient: event.target.value,
        });
        this.setState({pro: pro}); 
    } 

    handleDataChanged = (champ) => (event) => {
        this.data.client[champ] = event.target.value;
        this.setState({
            [champ]: event.target.value,
        });
    }

    renderChampClient = (style) => {      
        var styleBoutonAddPers={};  
        if(this.state.pro || this.state.nbPersonne > 1) {
            styleBoutonAddPers={'display': 'none'}
        }
        return (
            <div id="infosClient" style={style}>
                <div className="infosClientInner">
                    <TextField type = "number"
                    name = "clientNumero"
                    label = "Num&eacute;ro client"
                    className = "clientNumero"
                    value={this.state.numero}
                    onChange={this.handleDataChanged("numero")}
                    inputProps = {
                        {
                            readOnly: true,
                            disabled: true,
                        }
                    }
                    />
                    <IconButton
                        aria-haspopup="true"
                        onClick={this.handleAddPers}
                        className="infosClientAddPers"
                        color="primary"
                        title="Ajouter une personne"
                        style={styleBoutonAddPers}>
                        <AddCircle />
                    </IconButton>
                    <FormControl component="fieldset" className="typeClient">
                        <FormLabel component="legend">Type de client</FormLabel>
                        <RadioGroup
                            aria-label="typeClientCheckBox"
                            name="typeClientCheckBox"            
                            value={this.state.typeClient}
                            onChange={this.handleChangeTypeClient}
                            className="typeClientCheckBox">
                            <FormControlLabel value="part" control={<Radio color="primary" />} label="Particulier" />
                            <FormControlLabel value="pro" control={<Radio color="primary" />} label="Professionnel" />
                        </RadioGroup>
                    </FormControl>
                    <TextField name='obs' label='Observations' multiline={true} fullWidth={true} className="obs" value={this.state.obs} onChange={this.handleDataChanged("obs")} />
                </div>
            </div> 
        );
    }

    loadSelectedClient(){
        var retour=[];
        if(this.state.pro) {
                retour.push(<Professionnel key={0} professionnel={this.data.professionnel[0]} />);
        } else {
            for(var i=0; i< this.state.nbPersonne; i++){
                retour.push(<Personne key={i} personne={this.data.personnes[i]} id={i} removePers={this.handleRemovePers} />);
            }
        }
        return retour;
    }

    render(){
        var styleBlockPersonne = {};
        var styleBlockClient = {};
        var styleSeparator = {};
        var clientSelected = this.loadSelectedClient();
        if (super.size.width < 1160) {
            styleSeparator={'display': 'none'};
        }
        if (super.size.width > 600) {
            styleBlockClient={'width': '560px'}
        }
        return (<div id='client'>            
            <form  action="/" method="POST" onSubmit={this.handleSubmit}>
                <div className="separator" style={styleSeparator} />
                {this.renderChampClient(styleBlockClient)}
                <div className="separator" />
                <div className="editDiv" style={styleBlockPersonne}>
                    {clientSelected}
                </div>
            </form>
        </div>);
    }
}

Client.defaultProps = {
    numeroClient: null,
    popin: false,
}

Client.propTypes = {
    numeroClient: PropTypes.string,
    popin: PropTypes.bool,
};

export default Client;


// WEBPACK FOOTER //
// ./src/components/content/client/Client.js